import i18n from 'i18next';
import * as Yup from 'yup';

export const REQUIRED_MESSAGE = () => i18n.t('Required', { ns: 'global' });

export const STRING_REQUIRED_SCHEMA = Yup.string().required(REQUIRED_MESSAGE);
